import React from 'react'
import Grid from '@mui/material/Grid'
import Carousel from 'react-multi-carousel'
import { popularMotorcycleBrands } from 'constants/motorcycles/brands'
import { responsive } from 'components/brands/landingPage/brandDataHelper'
import { Link } from 'react-router-dom'
import './homePageBrands.css'
import 'react-multi-carousel/lib/styles.css'
import '../../../brands/landingPage/brandLandingPage.css'

const HomePageBrands = (props) => {
  const { isMobile } = props

  return (
    <div className='mb-6'>
      <h2 className={`is-size-4 has-text-weight-extra-bold mb-4 has-black-dark-text ${isMobile ? 'has-text-centered' : ''}`}>
        Popular Motorcycle Brands
      </h2>
      <div>
        <Carousel infinite={true} shouldResetAutoplay={false} responsive={responsive}>
          {popularMotorcycleBrands.map((brand, i) => (
            <span
              key={'locationMobile' + i}
            >
              <Link to={`brand/${brand.url}`}>
                <Grid xs={12} textAlign="center">
                  <img
                    alt={brand.name + 'Img'}
                    src={brand.imagePath}
                    className="brand-images"
                  />
                    <div className="home-page-location-names">{brand.name}</div>
                </Grid>
              </Link>
            </span>
          ))}
        </Carousel>
      </div>
    </div>
  )
}

export default HomePageBrands
